import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Loading from "../loading";
import axios from "axios";
import Slider, { SliderTooltip } from "rc-slider";
import { BsCloudUpload } from "react-icons/bs";
import { FaEquals } from "react-icons/fa";
import { FcApproval } from "react-icons/fc";
import { useMediaQuery } from "@chakra-ui/media-query";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import CSVReader from "react-csv-reader";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DateTimePicker from "react-datetime-picker";
import { Link } from "react-router-dom";
import moment from "moment";
import PresaleGeneralBNBABI from "../../utils/presaleGeneralBNBABI.json";
import Environment from "../../utils/Environment";
import { Grid, Box, Avatar, Container, IconButton } from "@material-ui/core";
import ShareIcon from "@material-ui/icons/Share";
import CopyToClipboard from "react-copy-to-clipboard";
const useStyles = makeStyles((theme) => ({
  progressDone: {
    borderRadius: "20px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "0",
    opacity: 0,
    fontSize: "12px",
    transition: "1s ease 0.3s",
    background: "#00B7C5",
  },
  progress: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    position: "relative",
    margin: "15px 0",
    height: "10px",
    width: "100%",
  },
  orange: {
    color: "#fff",
    backgroundColor: "tranparent",
    border: "3px solid #00B7C5",
    // padding: "40px",
    width: "100px",
    height: "100px",

    overflow: "visible",
    zIndex: 100,
    position: "relative",
    "& img": {
      borderRadius: "100%",
      position: "relative",
      zIndex: 20,
    },
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.6s infinite ease-in-out",
      border: "2px solid #00B7C5",
      content: '""',
      zIndex: 10,
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.6)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(1.4)",
      opacity: 0,
    },
  },
}));

const Sales = ({ data }) => {
  const classes = useStyles();
  const { Handle } = Slider;
  const {
    userWalletAddress = "",
    network = "",
    bnbBalance = 0,
    salesContract = "",
    web3,
  } = useSelector((state) => state.UserReducer);
  const [style, setStyle] = React.useState({});
  const [open, setopen] = useState([]);

  const [remaining, setremaining] = useState(0);
  const [loading, setloading] = useState(false);
  const [buyContract, setbuyContract] = useState("");
  const [amount, setamount] = useState("");
  const [tokenBalance, settokenBalance] = useState(0);
  const [soldToken, setsoldToken] = useState(0);

  const {
    date,
    fileData,
    _id,
    tokenAddress,
    tokenSymbol,
    tokenDecimel,
    tokenName,
    hardCap,
    softCap,
    priceOfTokenOnSales,
    startTime,
    endTime,
    limit,
    minLimit,
    maxLimit,
    sale,
    referralPercent,
    referral,
    releasePercent,
    month,
    logoLink,
    liquidityPercent,
    pancakeListingPrice,
    projectStatus,
    webLink,
    githubLink,
    twitterLink,
    redditLink,
    telegramLink,
    projectDescription,
    updateyouwant,
    projectName,
  } = data;
  const { spacing } = useTheme();
  React.useEffect(() => {
    setTimeout(() => {
      const newStyle = {
        opacity: 0.8,
        width: `${remaining}%`,
        fontSize: "10px",
      };

      setStyle(newStyle);
    }, 200);
  }, [remaining]);
  useEffect(() => {
    const init = async () => {
      const contractAddress = await salesContract.methods
        .getPreSale(Environment.defaultAddress, tokenAddress)
        .call();
      console.log(contractAddress);

      const contract = await new web3.eth.Contract(
        PresaleGeneralBNBABI,
        contractAddress
      );
      const tokenBalance = await contract.methods
        .getContractTokenBalance()
        .call();

      const decimal = Math.pow(10, +tokenDecimel);
      settokenBalance(tokenBalance / decimal);
      const soldTokens = await contract.methods.soldTokens().call();
      setsoldToken(soldTokens / decimal);
      var remaining = (soldTokens / tokenBalance) * 100;
      console.log(remaining);
      setremaining(remaining);
    };
    if (data && salesContract) {
      init();
    }
  }, [salesContract, data]);

  console.log(remaining);
  return (
    <Grid
      item
      style={{ textDecoration: "none", color: "secondary.main" }}
      xs={12}
      md={6}
      // key={index}

      style={{ position: "relative" }}
    >
      <Box
        borderRadius="10px"
        bgcolor="#EDFAFB"
        border="2px solid #00B7C5"
        px={spacing(1)}
        py={spacing(0.2)}
      >
        {referral == "yes" && (
          <Box position="absolute" right="5%">
            <IconButton>
              <CopyToClipboard
                onCopy={() => {
                  userWalletAddress
                    ? toast.success("Success! Link copied!")
                    : toast.error("Error! Please connect your wallet!");
                }}
                text={
                  userWalletAddress &&
                  window.location.origin +
                    "/join-sales/" +
                    _id +
                    "/?ref=" +
                    userWalletAddress
                }
              >
                <ShareIcon color="secondary.main" />
              </CopyToClipboard>
            </IconButton>
          </Box>
        )}
        <Box display="flex">
          <Box component="h3" fontSize={spacing(2.5)} pt={spacing(0.2)}>
            <Avatar className={classes.orange} src={logoLink}></Avatar>
          </Box>

          <Box
            component="h3"
            fontSize={spacing(2.5)}
            mt={spacing(0.5)}
            ml={spacing(0.3)}
          >
            <Box
              component={Link}
              to={`/join-sales/${_id}`}
              style={{ display: "block", marginBottom: "10px" }}
            >
              {" "}
              {projectName}
            </Box>{" "}
            <a
              target="_blank"
              style={{ textDecoration: "none", color: "#fff" }}
              textDecoration="none"
              href={webLink}
            >
              <Box
                component="span"
                p={spacing(0.1)}
                borderRadius="100%"
                bgcolor="secondary.main"
                fontSize={spacing(2)}
                className="fas fa-globe"
              ></Box>
            </a>
            <a
              target="_blank"
              style={{ textDecoration: "none", color: "#fff" }}
              textDecoration="none"
              href={twitterLink}
            >
              <Box
                component="span"
                ml={spacing(0.1)}
                p={spacing(0.1)}
                borderRadius="100%"
                bgcolor="secondary.main"
                fontSize={spacing(2)}
                className="fab fa-twitter"
              ></Box>
            </a>
            <a
              target="_blank"
              style={{ textDecoration: "none", color: "#fff" }}
              textDecoration="none"
              href={telegramLink}
            >
              <Box
                component="span"
                ml={spacing(0.1)}
                p={spacing(0.1)}
                borderRadius="100%"
                bgcolor="secondary.main"
                fontSize={spacing(2)}
                className="fab fa-telegram-plane"
              ></Box>
            </a>
            <a
              target="_blank"
              style={{ textDecoration: "none", color: "#fff" }}
              textDecoration="none"
              href={githubLink}
            >
              <Box
                component="span"
                ml={spacing(0.1)}
                p={spacing(0.1)}
                borderRadius="100%"
                bgcolor="secondary.main"
                fontSize={spacing(2)}
                className="fab fa-github"
              ></Box>
            </a>
            <Box
              component="p"
              borderRadius="20px"
              align="left"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p={spacing(0.1)}
              color="white"
              fontSize={spacing(1.6)}
              bgcolor="secondary.main"
              my={1}
              style={{ textTransform: "capitalize" }}
            >
              <Box
                component="span"
                // ml={spacing(0.05)}
                mr={spacing(0.1)}
                fontSize={spacing(2)}
                className="fas fa-dot-circle"
              ></Box>
              {projectStatus}
            </Box>
            <Box
              component="p"
              borderRadius="20px"
              align="left"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p={spacing(0.1)}
              color="white"
              fontSize={spacing(1.6)}
              bgcolor="secondary.main"
              my={1}
              style={{ textTransform: "capitalize" }}
            >
              <Box
                component="span"
                // ml={spacing(0.05)}
                mr={spacing(0.1)}
                fontSize={spacing(2)}
                className="fas fa-dot-circle"
              ></Box>
              {fileData.length !== 0 ? "Private" : "Public"}
            </Box>
          </Box>
        </Box>
        <Box
          component="h3"
          color="text.secondary"
          align="left"
          fontSize={spacing(2)}
          my={spacing(0.2)}
          ml={spacing(0.3)}
        >
          {projectDescription}
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Box
            component="h3"
            color="#999"
            fontSize={spacing(1.6)}
            fontWeight={500}
            ml={spacing(0.3)}
          >
            Liquidity Allocation
            <br />
            <Box
              component="h3"
              color="secondary.main"
              fontSize={spacing(4)}
              my={0}
            >
              {liquidityPercent}%
            </Box>
          </Box>
          <Box
            component="h3"
            color="#999"
            fontSize={spacing(1.6)}
            fontWeight={500}
            ml={spacing(0.3)}
          >
            Hard Cap <br />
            <Box
              component="h3"
              color="secondary.main"
              fontSize={spacing(4)}
              my={0}
            >
              {hardCap}
            </Box>
          </Box>
          <Box
            component="h3"
            color="#999"
            fontSize={spacing(1.6)}
            fontWeight={500}
            ml={spacing(0.3)}
          >
            Soft Cap <br />
            <Box
              component="h3"
              color="secondary.main"
              fontSize={spacing(4)}
              my={0}
            >
              {softCap}
            </Box>
          </Box>
        </Box>
        <Box
          component="h3"
          color="#999"
          align="left"
          fontSize={spacing(1.6)}
          fontWeight={500}
          ml={spacing(0.3)}
          my={0}
        >
          Access{" "}
        </Box>
        <Box className={classes.progress} my={0}>
          <Box className={classes.progressDone} style={style}></Box>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          fontWeight={600}
          flexWrap="wrap"
        >
          <Box component="span" fontSize={spacing(2)} ml={spacing(0.3)} my={0}>
            {remaining.toFixed(2)}%
          </Box>
          <Box component="span" fontSize={spacing(2)} ml={spacing(0.3)} my={0}>
            {soldToken} {tokenSymbol}/{tokenBalance} {tokenSymbol}
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default Sales;
